var map = {
	"./cyber-security.jpg": 57810,
	"./microsoft-365.jpg": 67611,
	"./microsoft-azure.jpg": 44713,
	"./power-automate.jpg": 85867,
	"./power-bi.jpg": 52997,
	"./students.jpg": 82881
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 758;